import { useEffect, useState } from 'react';
import ContextTip from '@/components/ContextTip';
import { useTipPrefs } from '@/hooks/useTipPrefs';
import { getFeatureUsage } from '@/lib/api';

const TIP_ID = 'ctx-templates';

/**
 * Suggests saving the medicines as a template — only for doctors who have never
 * saved one, and only once they've entered a combination worth saving.
 */
export default function TemplateTip({ medicineCount, onSave }: { medicineCount: number; onSave: () => void }) {
  const { isActive, markSeen, recordView } = useTipPrefs();
  const active = isActive(TIP_ID);
  const [hasTemplates, setHasTemplates] = useState<boolean | null>(null);

  useEffect(() => {
    if (!active) return;
    getFeatureUsage().then(u => setHasTemplates(u.templates)).catch(() => {});
  }, [active]);

  const visible = active && hasTemplates === false && medicineCount >= 2;
  // Counts toward the "at most N days" limit, so an ignored tip retires by itself
  useEffect(() => { if (visible) recordView(TIP_ID); }, [visible, recordView]);

  if (!visible) return null;

  return (
    <div className="pb-2">
      <ContextTip
        action={{ label: 'Save as template', onClick: () => { markSeen(TIP_ID); onSave(); } }}
        onDismiss={() => markSeen(TIP_ID)}
      >
        Prescribe this combination often? Save it as a template and load it in one click next time.
      </ContextTip>
    </div>
  );
}
